module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter02"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When life gives you lemons, you make lemonade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When life gives "), _c('em', [_vm._v("me")]), _vm._v(" lemons, I pour a glass of vodka on the rocks and call it a day. But don’t get me wrong, I’m not a lush. I’m a God-fearing Christian woman who carries the Bible with her everywhere, but that’s only because my Good Book doubles as a phone book. I used all the blank pages in the back to write down the numbers I can’t remember.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Forgive me Lord for being a heathen.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This story is about human beings, who would be perfect if they weren’t so flawed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My friend, this is the story of me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And, oh yeah, it’s about you, too.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7266587b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 75
// module chunks = 0